/* eslint-disable no-unused-vars */
import { ReactElement, useEffect } from 'react'
import { Table } from 'react-bootstrap'
import {
  PageWrapper,
  SectionTitle,
  TableWrapper,
  TableHeader,
  Loader
} from '../../../../components'
import strings from '../../../../locale/en'
import { TableRow } from '../../User/subcomponents'
import { tableHeader } from './consts'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { getLeaveMasterDetails } from '../../../../redux/manageLeave/action'
import { LeaveMaster } from '../../../../redux/manageLeave/type'

const LeaveMasterDetails = (): ReactElement => {
  const { leaveMasterDetails, isLoading } = useSelector(
    (state: RootState) => ({
      leaveMasterDetails: state.leave.leaveMasterDetails,
      isLoading: state.leave.isLoading
    }),
    shallowEqual
  )
  const dispatch = useDispatch()

  const {
    menu: {
      leave: { leaveMasterDetails: title }
    }
  } = strings

  useEffect(() => {
    dispatch(getLeaveMasterDetails())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <SectionTitle title={title} hasBorder /> 
        <div>
          {/* <TableWrapper>
            <Table size="sm" responsive="sm">
              <TableHeader>
                <TableRow>
                  {tableHeader?.map((header, index) => (
                    <th key={`leave-master-details-header-${index}`}>
                      {header}
                    </th>
                  ))}
                </TableRow>
              </TableHeader>
              <tbody>
                {leaveMasterDetails?.map(
                  ({ leaveName, encashable }: LeaveMaster, index) => (
                    <TableRow key={`leave-master-${index}`}>
                      <td>{leaveName}</td>
                      <td>{encashable ? 'True' : 'False'}</td>
                    </TableRow>
                  )
                )}
              </tbody>
            </Table>
          </TableWrapper> */}
        </div> 
    </PageWrapper>
  )
}

export default LeaveMasterDetails
